// Profil (design_handoff_profil): reine Hilfen, fachlich unverändert aus ProfileView herausgelöst.

/** Profil des angemeldeten Benutzers, wie App.tsx es an ProfileView gibt (nur die hier genutzten Felder). */
export interface ProfilDaten {
  id: string;
  full_name?: string | null;
  email?: string | null;
  role?: string | null;
  status?: string | null;
  avatar_url?: string | null;
  created_at?: string | null;
}

/** Initialen wie bisher: Anfangsbuchstaben aller Namensteile, höchstens zwei; ohne Namen „AD“. */
export function getInitials(name: string | null | undefined): string {
  return name?.split(' ').map((n) => n[0]).join('').toUpperCase().substring(0, 2) || 'AD';
}

/** Passwort-Prüfung vor dem Speichern – gleiche Reihenfolge und Texte wie bisher; null = in Ordnung. */
export function pruefePasswort(neu: string, bestaetigt: string): string | null {
  if (neu !== bestaetigt) return 'Die Passwörter stimmen nicht überein.';
  if (neu.length < 6) return 'Das Passwort muss mindestens 6 Zeichen lang sein.';
  return null;
}

/** Geräte-Icon der Login-Historie: Laptop bei Windows/Mac, sonst Smartphone (Logik unverändert). */
export function geraetArt(os: string): 'laptop' | 'smartphone' {
  const o = os.toLowerCase();
  return o.includes('windows') || o.includes('mac') ? 'laptop' : 'smartphone';
}

const ROLLEN: Record<string, string> = {
  'super admin': 'Super Admin',
  'master admin': 'Master Admin',
  admin: 'Admin',
  team: 'Team',
  hausmeister: 'Hausmeister',
  mieter: 'Mieter',
  eigentuemer: 'Eigentümer',
  dienstleister: 'Dienstleister',
};

/** Lesbares Rollen-Label (Freigabe 18.10.2026): bekannte Rollen übersetzt, unbekannt = Rohwert, leer = „Benutzer“. */
export function rollenLabel(rolle: string | null | undefined): string {
  const r = (rolle ?? '').trim();
  if (!r) return 'Benutzer';
  return ROLLEN[r.toLowerCase()] ?? r;
}

/** Status mit großem Anfangsbuchstaben, Fallback „Aktiv“. */
export function statusLabel(status: string | null | undefined): string {
  const s = (status ?? '').trim();
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : 'Aktiv';
}
